<div *ngIf="!init" style="align-self: center">
  <mat-spinner style="margin: auto" color="primary" diameter="24"></mat-spinner>
</div>
<div *ngIf="init" class="placer-project-container">
  <div class="button-container">
    <div class="action-buttons">
      <div class="placement-button">
        <button
          class="start-timer action-button clickable placement-button-height"
          [disabled]="taskStarted || disallowStartTask"
          [ngClass]="
            taskStarted || disallowStartTask ? 'start-timer-disabled' : ''
          "
          (click)="startTask()"
        >
          {{ placementStarted ? 'Laden gestart' : 'Start laden' }}
        </button>
      </div>
    </div>
    <span class="project-id align-right"
      >#{{ task.subProject.project.id }}</span
    >
  </div>

  <div class="banner project-type-banner" [ngClass]="bannerClass">
    <div class="banner-text center-text">{{ bannerText }}</div>
  </div>

  <p *ngIf="timeBudget?.length > 0" class="strong center-text">
    Voorziene timing: {{ timeBudget }}
  </p>

  <ng-container *ngIf="projectContactGroups?.length > 0">
    <div class="form-title">
      <div class="form-title-text">
        {{ projectContactGroups.length === 1 ? 'Bedrijf' : 'Bedrijven' }}
      </div>
    </div>

    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div
        *ngFor="
          let pcg of projectContactGroups;
          let first = first;
          let last = last
        "
      >
        <div [ngClass]="first ? '' : 'upper-space'" class="contact-group">
          <div *ngIf="pcg.contacts != null && pcg.contacts.length > 0">
            <div
              class="font-weight-bold click-link"
              (click)="openCompanyDisplayDialog(pcg.company)"
            >
              {{ pcg.company.regularName }}
            </div>
            <div *ngFor="let groupContact of pcg.contacts" class="d-flex">
              <div>
                <span *ngIf="groupContact.firstName"
                  >{{ groupContact.firstName }}
                </span>
                <span *ngIf="groupContact.lastName">{{
                  groupContact.lastName
                }}</span>
              </div>
              <div
                *ngFor="let phone of groupContact.telephones; let first = first"
              >
                <span>&nbsp;/&nbsp;</span>
                <a class="click-link" href="tel:{{ phone.number }}">
                  {{ phone.number | asFormatPhoneNumber }}
                </a>
              </div>
              <div *ngFor="let email of groupContact.emails; let first = first">
                <span>&nbsp;/&nbsp;</span>
                <a
                  class="click-link"
                  href="{{
                    email.email
                      | mailSubjectBodyLink
                        : task.subProject.project.id
                        : groupContact.firstName
                        : task.subProject.projectPlacement?.address?.line1
                        : task.subProject.projectPlacement?.address?.postalCode
                        : task.subProject.projectPlacement?.address?.city
                  }}"
                >
                  {{ email.email }}
                </a>
              </div>
            </div>
          </div>
          <div
            *ngIf="pcg.company.immoscoop || pcg.company.spotto || inpressLogo"
          >
            <img
              *ngIf="pcg.company.immoscoop"
              src="/assets/immoscoop_banner.png"
              class="immoscoop-logo"
            />
            <img
              *ngIf="pcg.company.spotto"
              src="/assets/spotto_banner.png"
              class="spotto-logo"
            />
            <img
              *ngIf="inpressLogo"
              src="/assets/logo.png"
              class="inpress-logo"
            />
          </div>
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="productDisplay != null">
    <div class="form-title">
      <div class="form-title-text">Product info</div>
    </div>

    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div class="product-display">
        <div class="product-display-text">
          <div class="placer-card-header">
            {{ productDisplay.productType }}
          </div>
          <div>
            <span class="strong">Type: </span>
            <span>{{ productDisplay.productType }}</span>
          </div>
          <div
            *ngIf="
              productDisplay.materialLine != null &&
              productDisplay.materialLine.length > 0
            "
          >
            <span class="strong">Materiaal: </span
            ><span>{{ productDisplay.materialLine }}</span>
          </div>
          <div
            *ngFor="let subProductDisplay of productDisplay.subProductDisplays"
          >
            <ng-container *ngIf="subProductDisplay.line.length > 0">
              <span class="strong">{{ subProductDisplay.header }} </span>
              <span>{{ subProductDisplay.line }}</span>
            </ng-container>
          </div>
          <ng-container
            *ngIf="
              productDisplay.title?.length > 0 ||
              productDisplay.text?.length > 0 ||
              productDisplay.productPhoneNumbers?.length > 0
            "
          >
            <div class="small-upper-space">
              <ul class="inpress-ul">
                <li *ngIf="productDisplay.title?.length > 0">
                  <span class="strong">Titel: </span>
                  <span>{{ productDisplay.title }}</span>
                </li>
                <li *ngIf="productDisplay.text?.length > 0">
                  <span class="strong">Tekst: </span>
                  <span>{{ productDisplay.text | shortenText : 30 }}</span>
                </li>
                <li *ngIf="productDisplay.productPhoneNumbers?.length > 0">
                  <span class="strong">Tel:&nbsp;</span>
                  <span
                    *ngFor="
                      let phone of productDisplay.productPhoneNumbers;
                      let first = first
                    "
                  >
                    <span *ngIf="!first">&nbsp;/&nbsp;</span>
                    <a class="click-link" href="tel:{{ phone }}">{{ phone }}</a>
                  </span>
                </li>
              </ul>
            </div>
          </ng-container>
        </div>
        <div class="product-display-execution-and-assets">
          <ng-container *ngIf="productDisplay.album?.length === 1">
            <div class="single-design-photo photo-margin">
              <img
                class="max-asset-width max-asset-height clickable"
                src="{{ productDisplay.album[0].preview }}"
                (click)="openAlbumLightbox(productDisplay.album, index)"
              />
            </div>
          </ng-container>
          <ng-container *ngIf="productDisplay.album?.length > 1">
            <div class="design-photo-grid photo-margin">
              <img
                *ngFor="let asset of productDisplay.album; let index = index"
                class="max-asset-width max-asset-height clickable"
                src="{{ asset.preview }}"
                (click)="openAlbumLightbox(productDisplay.album, index)"
              />
            </div>
          </ng-container>
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="adjustmentDisplay != null">
    <div class="info-banner" [ngClass]="bannerClass">
      <div class="project-type-banner banner-text info-banner-text">
        {{ adjustmentDisplay.infoTitle }}
      </div>
    </div>

    <mat-card class="mat-elevation-z0 overflow-hidden vertically-center">
      <div class="product-display">
        <div class="product-display-text">
          <div
            *ngIf="adjustmentDisplay.adjustmentInfo?.length > 0"
            class="under-space"
          >
            <span class="preserve-line-break">{{
              adjustmentDisplay.adjustmentInfo
            }}</span>
          </div>
          <ng-container
            *ngIf="adjustmentDisplay.adjustmentDisplayItems?.length > 0"
          >
            <div *ngFor="let item of adjustmentDisplay.adjustmentDisplayItems">
              <span class="strong">{{ item.header }}: </span>
              <span>{{ item.line }} </span>
            </div>
          </ng-container>
        </div>
        <div class="product-display-execution-and-assets">
          <ng-container *ngIf="adjustmentDisplay.album?.length === 1">
            <div class="single-design-photo">
              <img
                class="max-asset-width max-asset-height clickable"
                src="{{ adjustmentDisplay.album[0].preview }}"
                (click)="openAlbumLightbox(adjustmentDisplay.album, index)"
              />
            </div>
          </ng-container>
          <ng-container *ngIf="adjustmentDisplay.album?.length > 1">
            <div class="design-photo-grid">
              <img
                *ngFor="let asset of adjustmentDisplay.album; let index = index"
                class="max-asset-width max-asset-height clickable"
                src="{{ asset.preview }}"
                (click)="openAlbumLightbox(adjustmentDisplay.album, index)"
              />
            </div>
          </ng-container>
        </div>
      </div>
    </mat-card>
  </ng-container>

  <ng-container *ngIf="task.description?.length > 0">
    <div class="form-title">
      <div class="form-title-text">Opmerkingen laden</div>
    </div>

    <div class="banner appointment-banner">
      <div class="description-text">
        <span class="preserve-line-break">{{ task.description }}</span>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="extraMaterialsInfo?.length > 0">
    <div class="form-title">
      <div class="form-title-text">Extra materialen</div>
    </div>

    <mat-card class="internal-form mat-elevation-z0 no-top-margin">
      <div class="preserve-line-break">
        {{ extraMaterialsInfo }}
      </div>
    </mat-card>
  </ng-container>

  <div class="big-form-title">
    <div class="form-title-text">Laadlijst</div>
  </div>

  <ng-container *ngIf="productDisplay != null">
    <div class="upper-space strong">Details:</div>
    <ng-container
      *ngIf="
        productDisplay.paintedPostsTexts != null &&
        productDisplay.paintedPostsTexts.length <= 1
      "
    >
      <ng-container
        *ngTemplateOutlet="
          singlePaintedPosts;
          context: {
            paintedPostsText: productDisplay.paintedPostsTexts[0],
            productDisplay: productDisplay
          }
        "
      ></ng-container>
    </ng-container>
    <ng-container *ngIf="productDisplay.paintedPostsTexts?.length > 1">
      <ng-container
        *ngTemplateOutlet="
          multiplePaintedPosts;
          context: { productDisplay: productDisplay }
        "
      ></ng-container>
    </ng-container>
  </ng-container>

  <div class="upper-space">
    <ng-container
      *ngIf="
        loadList.tilingLoadEntry != null ||
        loadList.immoscoopAndOrSpottoAndOrInpressLoadEntry != null
      "
    >
      <div *ngIf="loadList.tilingLoadEntry != null">
        <div class="d-flex justify-content-between">
          <div class="static-load-entry">
            <span class="strong">{{ loadList.tilingLoadEntry.header }}</span>
            <span *ngIf="loadList.tilingLoadEntry.label != null"
              >: {{ loadList.tilingLoadEntry.label }}</span
            >
          </div>
          <mat-checkbox
            [(ngModel)]="loadList.tilingLoadEntry.loaded"
            [disabled]="task.complete || !taskStarted"
            (ngModelChange)="tilingLoadedChange()"
          ></mat-checkbox>
        </div>
      </div>
      <div *ngIf="loadList.immoscoopAndOrSpottoAndOrInpressLoadEntry != null">
        <div class="d-flex justify-content-between">
          <div class="static-load-entry">
            <span class="strong">{{
              loadList.immoscoopAndOrSpottoAndOrInpressLoadEntry.header
            }}</span>
          </div>
          <mat-checkbox
            [(ngModel)]="
              loadList.immoscoopAndOrSpottoAndOrInpressLoadEntry.loaded
            "
            [disabled]="task.complete || !taskStarted"
            (ngModelChange)="immoscoopAndOrSpottoAndOrInpressLoadedChange()"
          ></mat-checkbox>
        </div>
      </div>
    </ng-container>
  </div>

  <ng-container *ngIf="loadList.materialLoadEntries?.length > 0">
    <div class="upper-space d-flex">
      <div class="strong">Constructiematerialen</div>
      <img
        *ngIf="productDisplay?.sketchUpAlbum?.length > 0"
        class="sketch-up-album"
        [src]="'/assets/sketchup-square.svg'"
        height="24"
        (click)="openAlbumLightbox(productDisplay.sketchUpAlbum)"
      />
    </div>
    <div class="upper-space">
      <load-list-table
        [disabled]="task.complete || !taskStarted"
        [constructionMaterials]="loadList.materialLoadEntries"
        (change)="materialLoadChange()"
      ></load-list-table>
    </div>
  </ng-container>

  <div
    class="completable-task-executed-button-whitespace horizontal-center-wrapper"
  >
    <div class="horizontal-center-content">
      <div
        *ngIf="displayExecutionTime && executionTimeString?.length > 0"
        class="horizontal-center bottom-space"
      >
        <span class="strong">{{ executionTimeString }}</span>
      </div>
      <div class="d-flex">
        <ng-container *ngIf="submitInProgress || submitQueued">
          <div class="d-flex retry-submit-margin">
            <button
              *ngIf="submitQueued && !submitInProgress"
              mat-button
              class="button executed-button"
              [disabled]="submitting"
              (click)="retrySubmit()"
            >
              Manueel opnieuw proberen
            </button>
            <div
              *ngIf="submitQueued && !submitInProgress"
              matTooltip="Taak staat klaar om ingediend te worden"
            >
              <mat-icon class="queue-icon">cloud_queue</mat-icon>
            </div>
            <div *ngIf="submitInProgress" matTooltip="Taak wordt ingediend">
              <mat-spinner
                class="submitting-icon"
                color="primary"
                diameter="30"
              ></mat-spinner>
            </div>
          </div>
        </ng-container>
        <button
          class="completable-task-executed-button"
          [disabled]="
            !taskStarted ||
            !everythingLoaded ||
            storingOfflineChange ||
            submitting ||
            task.complete
          "
          [ngClass]="
            !taskStarted ||
            !everythingLoaded ||
            storingOfflineChange ||
            submitting ||
            task.complete
              ? 'button-disabled'
              : ''
          "
          (click)="submit()"
        >
          Uitgevoerd
        </button>
      </div>
    </div>
  </div>
</div>

<ng-template
  #singlePaintedPosts
  let-paintedPostsText="paintedPostsText"
  let-productDisplay="productDisplay"
>
  <div>
    <ng-container *ngIf="paintedPostsText?.length > 0">
      <span class="strong">Geschilderde constructie: </span>
      <span>{{ paintedPostsText }}</span>
    </ng-container>
    <ng-container
      *ngIf="
        paintedPostsText?.length > 0 && productDisplay.newWoodPosts?.length > 0
      "
    >
      <span class="preserve-span-space"> / </span>
    </ng-container>
    <ng-container *ngIf="productDisplay.newWoodPosts?.length">
      <span class="strong">Nieuw hout of recup: </span>
      <span>{{ productDisplay.newWoodPosts }}</span>
    </ng-container>
  </div>
</ng-template>

<ng-template #multiplePaintedPosts let-productDisplay="productDisplay">
  <div class="d-flex">
    <div class="strong">Geschilderde constructie:</div>
    <ul class="inpress-ul small-left-space">
      <li *ngFor="let paintedPostsText of productDisplay.paintedPostsTexts">
        {{ paintedPostsText }}
      </li>
    </ul>
  </div>
  <div class="new-wood-margin" *ngIf="productDisplay.newWoodPosts?.length > 0">
    <span class="strong">Nieuw hout of recup: </span>
    <span>{{ productDisplay.newWoodPosts }}</span>
  </div>
</ng-template>
